module.exports = __webpack_public_path__ + "media/packs/images/flags/JP-9867bef014bbd0a08d6cfbbf50bd016d.png";